import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/marketing/marketing";
import IntroRevenue from "./smartComponents/introRevenue";
import IntroRevenueChange from "./smartComponents/introRevenueChange";
import IntrosSold from "./smartComponents/introsSold";
import IntrosSoldChange from "./smartComponents/introsSoldChange";
import ProfilesCreated from "./smartComponents/profilesCreated";
import ProfilesCreatedChange from "./smartComponents/profilesCreatedChange";
import ProfilesToFirstVisit from "./smartComponents/profilesToFirstVisit";
import ProfilesToFirstVisitChange from "./smartComponents/profilesToFirstVisitChange";
import ReferralBySource from "./smartComponents/referralBySource";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
export class MarketingModule extends React.Component {
  static propTypes = {
    fetchCurrentUser: PropTypes.func.isRequired,
    updateAllData: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    currentUser: PropTypes.object,
    referralBySourceData: PropTypes.array
  };

  state = {
    initRequest: false,
    active: true
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Marketing")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      let state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Marketing") & !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  handleToggle = () => {
    this.setState({ active: !this.state.active });
  };

  render() {
    return (
      <SectionToggle
        title={`Marketing`}
        showCta={this.state.showGoals}
        isLoading={this.props.isLoading}
        height={350}
        content={
          <div id="marketingModule">
            <div className="section-group">
              <div className="width-50" style={{ width: "50%", height: "140px" }}>
                <SectionContainer title="Intro Revenue">
                  <IntroRevenue /> <IntroRevenueChange />
                </SectionContainer>
              </div>
              <div className="width-50" style={{ width: "50%", height: "140px" }}>
                <SectionContainer title="Intros Sold">
                  <IntrosSold /> <IntrosSoldChange />
                </SectionContainer>
              </div>
              {this.props.referralBySourceData.length > 0 && (
                <div>
                  <div className="width-50" style={{ width: "50%", height: "140px" }}>
                    <SectionContainer title="Profiles Created">
                      <ProfilesCreated /> <ProfilesCreatedChange />
                    </SectionContainer>
                  </div>
                  <div className="width-50" style={{ width: "50%", height: "140px" }}>
                    <SectionContainer title="Profiles to First Visit">
                      <ProfilesToFirstVisit /> <ProfilesToFirstVisitChange />
                    </SectionContainer>
                  </div>
                </div>
              )}
            </div>
            <div className="section-group">
              {this.props.referralBySourceData.length === 0 && (
                <div>
                  <div className="width-50" style={{ width: "50%", height: "140px" }}>
                    <SectionContainer title="Profiles Created">
                      <ProfilesCreated /> <ProfilesCreatedChange />
                    </SectionContainer>
                  </div>
                  <div className="width-50" style={{ width: "50%", height: "140px" }}>
                    <SectionContainer title="Profiles to First Visit">
                      <ProfilesToFirstVisit /> <ProfilesToFirstVisitChange />
                    </SectionContainer>
                  </div>
                </div>
              )}
              {this.props.referralBySourceData.length > 0 && (
                <SectionContainer customStyles="padding-left" title="Referral By Source (Top 4)">
                  <ReferralBySource />
                </SectionContainer>
              )}
            </div>
            <div className="clear-fix" />
          </div>
        }
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.marketing.isLoading,
    userParams: state.marketing.currentUser,
    referralBySourceData: state.marketing.referralBySource
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(MarketingModule);
